// extracted by mini-css-extract-plugin
export default {"top_menu_bar":"CategoryMenu_top_menu_bar__eXRyd","menu_buttons":"CategoryMenu_menu_buttons__Y629e"};